import React from 'react';
import BaseAvailabilitySiteType from './BaseAvailabilitySiteType';
import * as Icons from '../../sharedComponents/icons/Icons';

export class AvailabilitySiteManagement extends BaseAvailabilitySiteType {}
AvailabilitySiteManagement.defaultProps = {
    name: "Management Site",
    colorSupport: "02",
    icon: <Icons.IconFlag />
};
